import { createContext } from 'use-context-selector'
import { OrganizationSettingsContextProps } from './types'

export const OrganizationSettingsContext = createContext(
  {} as OrganizationSettingsContextProps
)
